module.exports = __webpack_public_path__ + "img/img_33@2x.c3f27850.png";